"use client";

import { Analytics, type BeforeSendEvent } from "@vercel/analytics/next";
import { SpeedInsights } from "@vercel/speed-insights/next";

/**
 * Redact potential kennitala (10-digit Icelandic national ID) from URLs
 * before sending analytics events to protect member PII.
 */
function beforeSend(event: BeforeSendEvent): BeforeSendEvent | null {
  const redacted = event.url.replace(/\b\d{6}-?\d{4}\b/g, "[REDACTED]");
  return { ...event, url: redacted };
}

export function VercelAnalytics() {
  if (process.env.NODE_ENV !== "production") return null;

  return (
    <>
      <Analytics beforeSend={beforeSend} />
      <SpeedInsights />
    </>
  );
}
